import { render, staticRenderFns } from "./kpsrTargetProcessDetail.vue?vue&type=template&id=50516a2b"
import script from "./kpsrTargetProcessDetail.vue?vue&type=script&lang=js"
export * from "./kpsrTargetProcessDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50516a2b')) {
      api.createRecord('50516a2b', component.options)
    } else {
      api.reload('50516a2b', component.options)
    }
    module.hot.accept("./kpsrTargetProcessDetail.vue?vue&type=template&id=50516a2b", function () {
      api.rerender('50516a2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kpsr/plan/kpsrTargetProcessDetail.vue"
export default component.exports